const landingTitle = 'EOE Landing -';

const TRACK_APPLY_001 = `${landingTitle} Apply 001 CTA`;
const TRACK_APPLY_002 = `${landingTitle} Apply 002 CTA`;
const TRACK_APPLY_003 = `${landingTitle} Apply 003 CTA`;
const TRACK_APPLY_004 = `${landingTitle} Apply 004 CTA`;
const TRACK_APPLY_005 = `${landingTitle} Apply 005 CTA`;
const TRACK_APPLY_006 = `${landingTitle} Apply 006 CTA`;
const TRACK_EXPERT_TESTIMONIAL_CTA = `${landingTitle} Expert Testimonial CTA`;
const TRACK_USP_BOOKINGSYSTEM_BLOCK = `${landingTitle} Usp Bookingsystem Block`;
const TRACK_USP_REPLAYREVIEWS_BLOCK = `${landingTitle} Usp Replayreviews Block;`;
const TRACK_USP_COACHAPPS_BLOCK = `${landingTitle} Usp Coachapps Block;`;
const TRACK_SUCCESS_SESSION_BLOCK = `${landingTitle} Success Session Block;`;
const TRACK_SUCCESS_GROWTH_BLOCK = `${landingTitle} Success Growth Block;`;
const TRACK_SUCCESS_COMMUNITY_BLOCK = `${landingTitle} Success Community Block;`;
const TRACK_FAQ_HOW_TO_BECOME_EXPERT = `${landingTitle} Faq How To Become Expert;`;
const TRACK_FAQ_DO_I_NEED_A_FOLLOWING = `${landingTitle} Faq Do I Need A Following;`;
const TRACK_FAQ_HOW_FIRST_SESSIONS_PAID_FOR = `${landingTitle} Faq How First Sessions Paid For;`;
const TRACK_FAQ_HOW_DO_REFUNDS_WORK = `${landingTitle} Faq How Do Refunds Work;`;
const TRACK_FAQ_IS_METAFY_EXCLUSIVE = `${landingTitle} Faq Is Metafy Exclusive;`;
const TRACK_FAQ_HOW_WILL_I_KNOW_IF_ACCEPTED = `${landingTitle} Faq How Will I Know If Accepted;`;
const TRACK_SHOWS_GAME_SPECIFC = `${landingTitle} Shows Game specific deep dives;`;
const TRACK_SHOWS_OTHER_EXPERTS = `${landingTitle} Shows collaborate with other experts;`;
const TRACK_SHOWS_SHARE_MORE = `${landingTitle} Shows share more of what you love;`;

export const landingPageTracking = {
  TRACK_APPLY_001,
  TRACK_APPLY_002,
  TRACK_APPLY_003,
  TRACK_APPLY_004,
  TRACK_APPLY_005,
  TRACK_APPLY_006,
  TRACK_EXPERT_TESTIMONIAL_CTA,
  TRACK_USP_BOOKINGSYSTEM_BLOCK,
  TRACK_USP_REPLAYREVIEWS_BLOCK,
  TRACK_USP_COACHAPPS_BLOCK,
  TRACK_SUCCESS_SESSION_BLOCK,
  TRACK_SUCCESS_GROWTH_BLOCK,
  TRACK_SUCCESS_COMMUNITY_BLOCK,
  TRACK_FAQ_HOW_TO_BECOME_EXPERT,
  TRACK_FAQ_DO_I_NEED_A_FOLLOWING,
  TRACK_FAQ_HOW_FIRST_SESSIONS_PAID_FOR,
  TRACK_FAQ_HOW_DO_REFUNDS_WORK,
  TRACK_FAQ_IS_METAFY_EXCLUSIVE,
  TRACK_FAQ_HOW_WILL_I_KNOW_IF_ACCEPTED,
  TRACK_SHOWS_GAME_SPECIFC,
  TRACK_SHOWS_OTHER_EXPERTS,
  TRACK_SHOWS_SHARE_MORE
};

const stepOneTitle = 'EOE Application 01 -';

const TRACK_LOGIN = `${stepOneTitle} Login`;
const TRACK_DISCORD = `${stepOneTitle} Discord`;
const TRACK_TWITCH = `${stepOneTitle} Twitch`;
const TRACK_GOOGLE = `${stepOneTitle} Google`;
const TRACK_APPLE = `${stepOneTitle} Apple`;
const TRACK_TOS = `${stepOneTitle} Tos`;
const TRACK_PRIVACY = `${stepOneTitle} Privacy`;
const TRACK_SIGNUP_CTA = `${stepOneTitle} Signup CTA`;

export const stepOneTracking = {
  TRACK_LOGIN,
  TRACK_DISCORD,
  TRACK_TWITCH,
  TRACK_GOOGLE,
  TRACK_APPLE,
  TRACK_TOS,
  TRACK_PRIVACY,
  TRACK_SIGNUP_CTA
};

const stepTwoTitle = 'EOE Application 02 -';

const TRACK_HAVING_TROUBLE = `${stepTwoTitle} Having Trouble`;
const TRACK_CONTINUE_CTA = `${stepTwoTitle} Continue CTA`;

export const stepTwoTracking = {
  TRACK_HAVING_TROUBLE,
  TRACK_CONTINUE_CTA
};

const stepThreeTitle = 'EOE Application 03 -';

const TRACK_HAVING_TROUBLE_THREE = `${stepThreeTitle} Having Trouble`;
const TRACK_GO_BACK = `${stepThreeTitle} Go Back`;
const TRACK_DO_IT_LATER = `${stepThreeTitle} Do It Later`;
const TRACK_CONTINUE_CTA_THREE = `${stepThreeTitle} Continue CTA`;

export const stepThreeTracking = {
  TRACK_HAVING_TROUBLE_THREE,
  TRACK_GO_BACK,
  TRACK_DO_IT_LATER,
  TRACK_CONTINUE_CTA_THREE
};

const stepFourTitle = 'EOE Application 04 -';

const TRACK_HAVING_TROUBLE_FOUR = `${stepFourTitle} Having Trouble`;
const TRACK_GO_BACK_FOUR = `${stepFourTitle} Go Back`;
const TRACK_DO_IT_LATER_FOUR = `${stepFourTitle} Do It Later`;
const TRACK_CONTINUE_CTA_FOUR = `${stepFourTitle} Continue CTA`;

export const stepFourTracking = {
  TRACK_HAVING_TROUBLE_FOUR,
  TRACK_GO_BACK_FOUR,
  TRACK_DO_IT_LATER_FOUR,
  TRACK_CONTINUE_CTA_FOUR
};

const interimAcceptancePopupTitle = 'EOE Application Interim Popup -';

const TRACK_COMPLETE_NEXT_STEPS_CTA = `${interimAcceptancePopupTitle} COMPLETE NEXT STEPS CTA`;

export const interimAcceptancePopupTracking = {
  TRACK_COMPLETE_NEXT_STEPS_CTA
};

const interimExpertDashboardTitle = 'EOE Interim Dashboard -';

const TRACK_GO_LIVE_CTA = `${interimExpertDashboardTitle} Go Live CTA`;
const TRACK_PREVIEW_PROFILE_CTA = `${interimExpertDashboardTitle} Preview Profile CTA`;
const TRACK_COPY_URL = `${interimExpertDashboardTitle} Copy Url`;
const TRACK_EDIT_PROFILE_CTA = `${interimExpertDashboardTitle} Edit Profile CTA`;
const TRACK_FIRST_VOUCH_DROPDOWN = `${interimExpertDashboardTitle} First Vouch Dropdown`;
const TRACK_FIRST_VOUCH_DROPDOWN_CTA = `${interimExpertDashboardTitle} First Vouch Dropdown CTA`;
const TRACK_SHARE_CTA = `${interimExpertDashboardTitle} Share CTA`;
const TRACK_ACHIEVEMENTS_DROPDOWN = `${interimExpertDashboardTitle} Achievements Dropdown`;
const TRACK_ACHIEVEMENTS_DROPDOWN_CTA = `${interimExpertDashboardTitle} Achievements Dropdown CTA`;
const TRACK_SETUP_LESSONS_DROPDOWN = `${interimExpertDashboardTitle} Set Up Lessons Dropdown`;
const TRACK_SETUP_LESSONS_DROPDOWN_CTA = `${interimExpertDashboardTitle} Set Up Lessons Dropdown CTA`;
const TRACK_COMPLETE_PROFILE_DROPDOWN = `${interimExpertDashboardTitle} Complete Profile Dropdown`;
const TRACK_COMPLETE_PROFILE_DROPDOWN_CTA = `${interimExpertDashboardTitle} Complete Profile Dropdown CTA`;
const TRACK_AVAILABILITY_DROPDOWN = `${interimExpertDashboardTitle} Availability Dropdown`;
const TRACK_AVAILABILITY_DROPDOWN_CTA = `${interimExpertDashboardTitle} Availability Dropdown CTA`;
const TRACK_PAYMENT_DETAILS_DROPDOWN = `${interimExpertDashboardTitle} Payment Details Dropdown`;
const TRACK_PAYMENT_DETAILS_DROPDOWN_CTA = `${interimExpertDashboardTitle} Payment Details Dropdown CTA`;
const TRACK_CONNECT_DISCORD_DROPWDOWN = `${interimExpertDashboardTitle} Connect Discord Dropdown`;
const TRACK_CONNECT_DISCORD_DROPWDOWN_CTA = `${interimExpertDashboardTitle} Connect Discord Dropdown CTA`;
const TRACK_TRAINING_PLAN_DROPDOWN = `${interimExpertDashboardTitle} Training Plan Dropdown`;
const TRACK_TRAINING_PLAN_DROPDOWN_CTA = `${interimExpertDashboardTitle} Training Plan Dropdown CTA`;
const TRACK_FAQ_HOW_WILL_I_KNOW_IF_ACCEPTED_INTERIM = `${interimExpertDashboardTitle} Faq How Will I Know If Accepted`;
const TRACK_FAQ_HOW_FIRST_SESSIONS_PAID_FOR_INTERIM = `${interimExpertDashboardTitle} Faq How First Sessions Paid For`;
const TRACK_FAQ_HOW_DO_REFUNDS_WORK_INTERIM = `${interimExpertDashboardTitle} Faq How Do Refunds Work`;
const TRACK_FAQ_IS_METAFY_EXCLUSIVE_INTERIM = `${interimExpertDashboardTitle} Faq Is Metafy Exclusive`;

export const interimExpertDashboardTracking = {
  TRACK_GO_LIVE_CTA,
  TRACK_PREVIEW_PROFILE_CTA,
  TRACK_COPY_URL,
  TRACK_EDIT_PROFILE_CTA,
  TRACK_FIRST_VOUCH_DROPDOWN_CTA,
  TRACK_FIRST_VOUCH_DROPDOWN,
  TRACK_SHARE_CTA,
  TRACK_AVAILABILITY_DROPDOWN_CTA,
  TRACK_PAYMENT_DETAILS_DROPDOWN_CTA,
  TRACK_CONNECT_DISCORD_DROPWDOWN_CTA,
  TRACK_TRAINING_PLAN_DROPDOWN_CTA,
  TRACK_ACHIEVEMENTS_DROPDOWN_CTA,
  TRACK_SETUP_LESSONS_DROPDOWN_CTA,
  TRACK_COMPLETE_PROFILE_DROPDOWN_CTA,
  TRACK_ACHIEVEMENTS_DROPDOWN,
  TRACK_SETUP_LESSONS_DROPDOWN,
  TRACK_COMPLETE_PROFILE_DROPDOWN,
  TRACK_AVAILABILITY_DROPDOWN,
  TRACK_PAYMENT_DETAILS_DROPDOWN,
  TRACK_CONNECT_DISCORD_DROPWDOWN,
  TRACK_TRAINING_PLAN_DROPDOWN,
  TRACK_FAQ_HOW_WILL_I_KNOW_IF_ACCEPTED_INTERIM,
  TRACK_FAQ_HOW_FIRST_SESSIONS_PAID_FOR_INTERIM,
  TRACK_FAQ_HOW_DO_REFUNDS_WORK_INTERIM,
  TRACK_FAQ_IS_METAFY_EXCLUSIVE_INTERIM
};

const sharePopupModalTitle = 'EOE Share Popup -';

const TRACK_POPUP_MODAL_CLOSE = `${sharePopupModalTitle} Close`;
const TRACK_POPUP_MODAL_COPY_LINK = `${sharePopupModalTitle} Copy Link`;
const TRACK_POPUP_MODAL_SHARE_TWITTER = `${sharePopupModalTitle} Share X`;

export const sharePopUpTracking = {
  TRACK_POPUP_MODAL_CLOSE,
  TRACK_POPUP_MODAL_COPY_LINK,
  TRACK_POPUP_MODAL_SHARE_TWITTER
};

const interimVouchProfileTitle = 'EOE Vouch Profile -';

const TRACK_UPVOTE = `${interimVouchProfileTitle} Upvote`;
const TRACK_GAME_PAGE_LINK = `${interimVouchProfileTitle} Game Page Link`;
const TRACK_SHARE_PROFILE = `${interimVouchProfileTitle} Share Profile`;
const TRACK_TWITCH_LINK = `${interimVouchProfileTitle} Twitch Link`;
const TRACK_DISCORD_LINK = `${interimVouchProfileTitle} Discord Link`;
const TRACK_TWITTER_LINK = `${interimVouchProfileTitle} X Link`;
const TRACK_YOUTUBE_LINK = `${interimVouchProfileTitle} Youtube Link`;
const TRACK_FACEBOOK_LINK = `${interimVouchProfileTitle} Facebook Link`;
const TRACK_INSTAGRAM_LINK = `${interimVouchProfileTitle} Instagram Link`;
const TRACK_CUSTOM_LINK = `${interimVouchProfileTitle} Custom Link`;
const TRACK_ACHIEVEMENTS_EXPAND = `${interimVouchProfileTitle} Achievements Expand`;
const TRACK_TRAINING_PLAN_EXPAND = `${interimVouchProfileTitle} Training Plan Expand`;
const TRACK_LESSON_EXPAND = `${interimVouchProfileTitle} Lesson Expand`;

export const interimVouchProfileTracking = {
  TRACK_UPVOTE,
  TRACK_GAME_PAGE_LINK,
  TRACK_SHARE_PROFILE,
  TRACK_TWITCH_LINK,
  TRACK_DISCORD_LINK,
  TRACK_TWITTER_LINK,
  TRACK_YOUTUBE_LINK,
  TRACK_FACEBOOK_LINK,
  TRACK_INSTAGRAM_LINK,
  TRACK_CUSTOM_LINK,
  TRACK_ACHIEVEMENTS_EXPAND,
  TRACK_TRAINING_PLAN_EXPAND,
  TRACK_LESSON_EXPAND
};

export const EOETracking = {
  interimVouchProfileTracking,
  sharePopUpTracking,
  interimExpertDashboardTracking,
  interimAcceptancePopupTracking,
  stepFourTracking,
  stepThreeTracking,
  stepTwoTracking,
  stepOneTracking,
  landingPageTracking
};
